module.exports = __webpack_public_path__ + "img/tech_md.b61422b.webp";